import { createAsyncThunk } from "@reduxjs/toolkit";
import getIconsByCategory from "../../api/get-icons-by-category";

const getIconsByCategoryAction = createAsyncThunk(
  "icons/getIconsByCategory",
  async (iconCategory: number) => {
    return await getIconsByCategory(iconCategory);
  }
);

export default getIconsByCategoryAction;
